<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button
        type="primary"
        size="small"
        @click="handelClickAdd"
      >
        创建规则
      </el-button>
    </div>

    <SpCardContent>
      <div class="box-shadow offical-intro">
        <div class="offical-intro__img">
          <img
            :src="require('@/assets/img/sop0-1.jpg')"
            style="width: 90%"
          >
        </div>
        <div class="offical-intro__text">
          <h4 class="title">
            群SOP
          </h4>
          <p class="content">
            针对用户群每一个阶段，发起特定的导购任务。使导购人员在企业微信与客户沟通过程中，得到系统规则给与的任务提示，并跟进执行。管理导购对群客户的阶段性任务管理。标准化业务流程，帮助导购完成任务。
          </p>
          <p>
            <img
              :src="require('@/assets/img/sop0.jpg')"
              style="width: 90%"
            >
          </p>
        </div>
      </div>
    </SpCardContent>

    <SpCardContent title="规则配置">
      <div class="box-shadow offical-intro">
        <div class="offical-intro__text">
          <p class="content">
            添加规则设置，选择关联导购任务
          </p>
          <p>
            <img
              :src="require('@/assets/img/sop1.jpg')"
              style="width: 100%"
            >
          </p>
        </div>
      </div>
    </SpCardContent>
    <SpCardContent title="导购任务执行">
      <div class="box-shadow offical-intro">
        <div class="offical-intro__text">
          <p class="content">
            导购在企业微信收到任务通知后，点击进入导购任务详情页，并执行任务
          </p>
          <p>
            <img
              :src="require('@/assets/img/sop2.jpg')"
              style="width: 60%"
            >
          </p>
        </div>
      </div>
    </SpCardContent>
  </div>
</template>

<script>
export default {
  name: 'NoShipSop',
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    // 新增任务
    handelClickAdd () {
      this.$router.push({ path: '/membership/membershipSopAdd' })
    }
  }
}
</script>

<style lang="scss" scoped>
.offical-intro {
  display: flex;
  align-items: center;
  justify-content: center;
  &__img {
    width: 70px;
    height: 70px;
  }
  &__text {
    flex: 1;
    .title {
      color: #333333;
      margin-bottom: 10px;
    }
    .content {
      color: #6666;
      font-size: 12px;
    }
  }
}
</style>
